// Number of top sectors (by portfolio weight) to analyze for each fund report.
export const TOP_FUND_SECTORS_FOR_TAILWINDS = 3;

// A cache row is considered stale when it is older than this many days.
// The writer sets expiresAt = generatedAt + CACHE_STALE_AFTER_DAYS days.
export const CACHE_STALE_AFTER_DAYS = 8;

// UI: show the "updated N days ago" banner only once the cache is at least
// this old. Intentionally 1 day less than CACHE_STALE_AFTER_DAYS so the
// banner surfaces during the final 24h before lazy regen kicks in on read.
export const CACHE_FRESHNESS_BANNER_THRESHOLD_DAYS = 7;

// Stitch call timeout — fail fast so a stuck stitch never delays a report.
// Raised 10s → 20s when the stitch call moved from Haiku to Sonnet (2026-04-19).
export const STITCH_TIMEOUT_MS = 20_000;
